import { defineStore } from "pinia";
import { getPageEditoriales, getPageEditoriale } from "@/api/articles";
import AuthService from "@/services/authService";

export const useArticlesStore = defineStore("articles", {
  state: () => ({
    articles: [],
    currentArticle: null,
    loading: false,
    error: null,
  }),

  getters: {
    filteredArticles: state => {
      return state.articles.filter(article => article.published === true).sort((a, b) => a.position - b.position);
    },

    articlesInRows: state => {
      const filtered = state.articles
        .filter(article => article.published === true)
        .sort((a, b) => a.position - b.position);

      const rows = [];
      for (let i = 0; i < filtered.length; i += 3) {
        rows.push(filtered.slice(i, i + 3));
      }
      return rows;
    },

    isLoading: state => state.loading,

    currentError: state => state.error,

    userChannel: () => {
      return AuthService.getUserChannel();
    },
  },

  actions: {
    async fetchArticles() {
      this.loading = true;
      this.error = null;

      try {
        const response = await getPageEditoriales();

        this.articles = Array.isArray(response) ? response : [];
      } catch (error) {
        this.error = error.message || "Erreur lors du chargement des articles";
        console.error("Erreur fetchArticles:", error);
      } finally {
        this.loading = false;
      }
    },

    /**
     * Récupère un article spécifique
     * @param {string|number} id - ID de l'article
     */
    async fetchArticle(id) {
      this.loading = true;
      this.error = null;

      try {
        const response = await getPageEditoriale(id);
        if (Array.isArray(response) && response.length > 0) {
          this.currentArticle = response[0];
        } else if (response && response["hydra:member"] && response["hydra:member"].length > 0) {
          this.currentArticle = response["hydra:member"][0];
        } else {
          this.currentArticle = response;
        }
      } catch (error) {
        this.error = error.message || "Erreur lors du chargement de l'article";
        console.error("Erreur fetchArticle:", error);
      } finally {
        this.loading = false;
      }
    },

    resetStore() {
      this.articles = [];
      this.currentArticle = null;
      this.loading = false;
      this.error = null;
    },
  },

  persist: {
    key: "articles-store",
    storage: localStorage,
    paths: [],
  },
});
